module.exports = __webpack_public_path__ + "static/img/095.040a7aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/095.png
// module id = /+Km
// module chunks = 0